<div class="main-router">
<div class="container-fluid pt-2">

   
      <button mat-raised-button color="primary" (click)="goBack()"><< Back</button>
                            <!--  height: 87%;position: absolute;width: 93% -->
    <div class="" style="    height: 87%;position: absolute;width: 93%;" *ngIf="paymethod==1">
        <h3 class="text-center">Please select payment Mode</h3>
        <div class="row blocks " >
        <div class="col-4 offset-4">
          <div class="card  float-center" (click)="makepaymentonline()" style="width: 100%; height:18rem;">
            <div class="card-body align-middle">
                <h4>Online</h4>
                <i class="fa faicon mt-5 fa-credit-card-alt"></i>
                    <p class="mt-4">Click here to make payment through Debit Card/Credit Card/Internet Banking</p>
            </div>
          </div>
        </div>
        <!-- <div class="col-4">
          <div class="card  float-center" (click)="makepaymentoffline()" style="width: 100%; height:18rem;">
            <div class="card-body">
                    <h4>Offline</h4>
                    <i class="fa faicon mt-5 fa-university"></i>
                        <p class="mt-4">Click here to upload challan received from Bank.</p>
            </div>
          </div>
        </div> -->
    </div>
    </div>
    <div class="list-group-item mt-2" *ngIf="paymethod!=1">
    <div class="row  mt-2" *ngIf="offlinePay==1">

        <div class="col-12">
          <div class="row  mt-2">
            <div class="col-12"><h4>Please Enter your Challan No.</h4></div>
            <div class="col-6">
                <div class="form-group">
                    <label for="exampleInputEmail1">Challan No</label>
                    <input type="text" [(ngModel)]="challanNo"   class="form-control" value=""  >
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <button mat-raised-button color="primary" (click)="verifyChallan()">Verify</button>
                </div>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="col-6" *ngIf="challanValid==0" >
                <div class="form-group">
                   <h3 style="color:red">The challanNo you entered is already used or doesn't exist. Please Confirm the challan no and enter again</h3>
                </div>
            </div>
            <div class="row mt-4" *ngIf="challanValid==1" >

                <div class="col-6"  >
                    <div class="form-group">
                        <label for="exampleInputEmail1">Challan No</label>
                        <input type="text" [(ngModel)]="ChallanId" [readonly]="true"   class="form-control"   >
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Worker Name</label>
                        <input type="text" [(ngModel)]="WrkName" [readonly]="true"   class="form-control"   >
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Mobile No</label>
                        <input type="text" [(ngModel)]="WrkMob" [readonly]="true"   class="form-control" >
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Years </label>
                        <input type="text" [(ngModel)]="WrkYr" [readonly]="true"   class="form-control"   >
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Fee </label>
                        <input type="text" [(ngModel)]="fee" [readonly]="true"   class="form-control"   >
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <label for="exampleInputEmail1" >UPload Fee Recipt</label>
                        <input type="file" (change)="fileEvent($event,filetypes,'feerecipt')" class="form-control" >
                    </div>
                </div>

                        <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Contractor Name </label>
                                <input type="text" [(ngModel)]="ContName"  class="form-control"   >
                            </div>
                        </div>

                         <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">start Date </label>
                                <input type="text" [(ngModel)]="startDate"    class="form-control"   >
                            </div>
                        </div>
                         <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">End Date </label>
                                <input type="text" [(ngModel)]="endDate"    class="form-control"   >
                            </div>
                        </div>
                         <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Total Days </label>
                                <input type="text" [(ngModel)]="tDate"    class="form-control"   >
                            </div>
                        </div>
                        <div class="col-12" *ngIf="paymentType==2" >
                            <div class="form-group">
                                <label for="exampleInputEmail1">Form 27</label>
                                <input type="file" (change)="fileEvent($event,filetypes,'form27')" class="form-control" value="">

                            </div>
                        </div>
                 <div class="col-12" *ngIf="paymentType==2" >
                            <div class="form-group">
                                <label for="exampleInputEmail1">Form 27</label>
                                <input type="file" (change)="fileEvent($event,filetypes,'form27')" class="form-control" value="">

                            </div>
                        </div>

                <div class="col-6">
                    <div class="form-group">
                        <button mat-raised-button color="primary" (click)="SubmitFeeDetails()">Save</button>
                    </div>
                </div>

              </div>
        </div>
    </div>
    <div class="row  mt-2" *ngIf="offlinePay==2">
                <div class="col-12">
                  <div class="row  mt-2">
                    <div class="col-12"><h4>Please Enter your Challan No.</h4></div>
                    <div class="col-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Challan No</label>
                            <input type="text" [(ngModel)]="challanNo"   class="form-control" value=""  >
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <button mat-raised-button color="primary" (click)="verifyChallan()">Verify</button>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                    <div class="col-6" *ngIf="challanValid==0" >
                        <div class="form-group">
                           <h3 style="color:red">The challanNo you entered is already used or doesn't exist. Please Confirm the challan no and enter again</h3>
                        </div>
                    </div>
                    <div class="row mt-4" *ngIf="challanValid==1" >

                        <div class="col-6"  >
                            <div class="form-group">
                                <label for="exampleInputEmail1">Challan No</label>
                                <input type="text" [(ngModel)]="ChallanId" [readonly]="true"   class="form-control"   >
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Worker Name</label>
                                <input type="text" [(ngModel)]="WrkName" [readonly]="true"   class="form-control"   >
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Mobile No</label>
                                <input type="text" [(ngModel)]="WrkMob" [readonly]="true"   class="form-control" >
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Years </label>
                                <input type="text" [(ngModel)]="WrkYr" [readonly]="true"   class="form-control"   >
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Fee </label>
                                <input type="text" [(ngModel)]="fee" [readonly]="true"   class="form-control"   >
                            </div>
                        </div>
                        <div class="col-12">
                        </div>
                        <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Contractor Name </label>
                                <input type="text" [(ngModel)]="ContName"  class="form-control"   >
                            </div>
                        </div>

                         <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">start Date </label>
                                <input type="text" [(ngModel)]="startDate"    class="form-control"   >
                            </div>
                        </div>
                         <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">End Date </label>
                                <input type="text" [(ngModel)]="endDate"    class="form-control"   >
                            </div>
                        </div>
                         <div class="col-3"  *ngIf="paymentType==2">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Total Days </label>
                                <input type="text" [(ngModel)]="tDate"    class="form-control"   >
                            </div>
                        </div>
                        <div class="col-12" *ngIf="paymentType==2" >
                            <div class="form-group">
                                <label for="exampleInputEmail1">Form 27</label>
                                <input type="file" (change)="fileEvent($event,filetypes,'form27')" class="form-control" value="">

                            </div>
                        </div>
                        <div class="col-12">
                            <form ngNoForm action="{{host}}/csc/pay" method="post" id="vlepay">
                                                <input type="hidden" id="vlechallanid" name="challanNo" value="">
                           </form>

                          <form ngNoForm action="{{payAction}}" method="post" #form>
                            <input type="hidden" id="msg" name="msg" value="{{payMsg}}">
                                <div class="form-group">
                                    <button mat-raised-button color="warn" (click)="backButton()">Back</button>
                                    <button mat-raised-button type="button" color="primary" *ngIf="userRole==undefined || userRole!='VLE'" (click)="submitPaymentEntry(form)" [disabled]="(isEnablePayment)?false:true">Make Payment</button>
                                    <button mat-raised-button type="button" color="primary" *ngIf="userRole!=undefined && userRole=='VLE'" (click)="paycscfee()" [disabled]="(isEnablePayment)?false:true">Make Payment</button>

                                </div>
                          </form>
                        </div>
                      </div>
                </div>
            </div>


  </div>



</div></div>
